import "./MaterialBalance.css";
import InputTable from "./InputTable";
import InteractiveChart from "./InteractiveChart";
import ResultTable from "./ResultTable";
import ResultTrend from "./ResultTrend";
import { CalculateButton } from "../../components/common/CalculateButton";
import { DownloadButton } from "../../components/common/DownloadButton";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector, useAppStore } from "../../store/hooks/hooks";
import { getDataForMaterialBalance } from "../../store/slices/pvtCalculatorSlice";
import { useCallback } from "react";
import { isEmptyRow, validateInputs } from "../../store/slices/materialBalanceCalculatorSlice";
import { useCalculatorMutation } from "../../store/slices/apiSlice";
import PressureAbandondedAndPvt from "./PressureAbandondedAndPvt";
import type { ISimpleField } from "../../interfaces/interfaces";

// const validated = (inputs: { error?: string | null }[]) => {
const validated = (inputs: ISimpleField[]) => {
	if (inputs.some(input => input.error != null))
		return false;

	return true;
};

const MaterialBalance = () => {
	const { t } = useTranslation();
	const pvtData = useAppSelector(getDataForMaterialBalance);
	const dispatch = useAppDispatch();
	const store = useAppStore();
	const [triggerCalculator, { isLoading }] = useCalculatorMutation();

	const getFormData = useCallback(() => {
		dispatch(validateInputs());

		const { inputTable, pressureAbandon } = store.getState().materialBalance;
		const rows = Object.values(inputTable);
		const fields = [pressureAbandon, ...rows.flatMap(row => [row.q, row.p])];
		if (!validated(fields)) {
			return;
		}

		const [firstRow, ...otherRows] = rows;
		const filledRows = [firstRow, ...otherRows.filter(row => !isEmptyRow(row))];
		const qParams: string = filledRows.filter(row => row.q.baseValue != null).map(row => row.q.baseValue).join(",");
		const pParams: string = filledRows.map(row => row.p.baseValue).join(",");

		if (pvtData.errors.length > 0) {
			return;
		}

		const qweryParams: Record<string, number | string> = {};
		pvtData.inputs.forEach(input => {
			qweryParams[input.queryName] = input.baseValue ?? 0;
		});

		// "trend_adjustment_factor": float(default = 1)(Это то, что пользователь может "двигать" на графике.Больше нуля)
		// "pressure_abandon": float, минимальное удовлетворяющее нас давление в скважине
		// "gas_production": список добытого газа по годам — строка через запятую без пробелов, точка как разделитель целой и дробной части
		// "pressure_res_average": список давлений на момент добычи газа по годам

		qweryParams["trend_adjustment_factor"] = 1;
		qweryParams["pressure_abandon"] = pressureAbandon.baseValue ?? 0;
		qweryParams["gas_production"] = qParams;
		qweryParams["pressure_res_average"] = pParams;

		console.log(qweryParams)

		return qweryParams;
	}, [dispatch, store, pvtData]);

	const onCalculate = useCallback(async () => {
		const formData = getFormData();
		if (!formData) {
			return;
		}

		triggerCalculator({
			calculator_type: "material_balance",
			...formData,
		});
	}, [getFormData, triggerCalculator]);


	return (
		<div className="material-balance__container">
			<div className="material-balance__input-result-container">
				<div className="material-balance__input-result">
					<PressureAbandondedAndPvt />
					<InputTable />
					<ResultTable />
				</div>
				<div className="material-balance__buttons">
					<CalculateButton onClick={onCalculate} disabled={false} />
					<DownloadButton getFormData={() => getFormData()} calculatorType="material-balance" disabled={false} title={`${t(`download`)} (${t(`ipr:well1_title`)})`} />
				</div>
			</div >
			<ResultTrend />
			{/* <InteractiveChart /> */}
		</div >
	);
};

export default MaterialBalance;